// extracted by mini-css-extract-plugin
export var grid = "search-pagination-link-module--grid--4d5d0";
export var gridWithRowGap = "search-pagination-link-module--grid--with-row-gap--41baf";
export var maxWidthContainer = "search-pagination-link-module--max-width-container--0a64b";
export var mt0 = "search-pagination-link-module--mt-0--eba64";
export var mt1 = "search-pagination-link-module--mt-1--ab7ec";
export var mt2 = "search-pagination-link-module--mt-2--044fe";
export var mt3 = "search-pagination-link-module--mt-3--8fbeb";
export var mt4 = "search-pagination-link-module--mt-4--6a61f";
export var mt5 = "search-pagination-link-module--mt-5--2837d";
export var mt6 = "search-pagination-link-module--mt-6--b664e";
export var removeVisuallyHidden = "search-pagination-link-module--remove-visually-hidden--7e087";
export var searchPaginationLink__btn = "search-pagination-link-module--search-pagination-link__btn--f2e71";
export var searchPaginationLink__btnDark = "search-pagination-link-module--search-pagination-link__btn--dark--2472c";
export var searchPaginationLink__visuallyHidden = "search-pagination-link-module--search-pagination-link__visually-hidden--caa07";
export var visuallyHidden = "search-pagination-link-module--visually-hidden--fcb3e";
export var widgetBase = "search-pagination-link-module--widget-base--53427";